module.exports = __webpack_public_path__ + "static/royal-beef-logo-d6f927d8d91180f3ef265c4ec28db9c5.png";